import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Transaction } from '@contracts/interfaces/transaction.interfaces';
import { JobService } from 'src/app/services/job.service';
import { TransactionsService } from 'src/app/services/transactions.service';
import { Job } from '@contracts/interfaces/job.interface';
import { ACCOUNT } from 'src/app/accounts';
import { InvoicesService } from 'src/app/services/invoices.service';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';

export interface DialogData {
  transaction: Transaction;
}

const TRANSFER_NOTE_MAX_LENGTH = 24;

@Component({
  selector: 'app-cash-dialog',
  templateUrl: 'cash.dialog.html',
  styleUrls: ['./cash.dialog.scss']
})
export class CashDialogComponent {
  public transaction: Transaction = null;

  public transferToAddInv = "";
  public transferToAddAmount = 0;

  public total = 0;

  constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public dialogRef: MatDialogRef<CashDialogComponent>,
        public transactionService: TransactionsService,
        public jobService: JobService,
        public InvoicesService: InvoicesService) {
        this.transaction = data.transaction;

        if (this.data.transaction.cashDeposit == undefined) {
          this.data.transaction.cashDeposit = [];
        }

        for (let transfer of this.transaction.cashDeposit) {
          transfer.invoice = this.truncateTransferNote(transfer.invoice);
          this.total += transfer.amount;
        }
    }

  deleteTransfer (index: number) {
    this.transaction.cashDeposit.splice(index, 1);
    this.transactionService.update(this.transaction).subscribe();
  }

  addTransfer() {
    // Lets find the invoice
    this.InvoicesService.get(Number(this.transferToAddInv.replace("inv ",""))).subscribe((r: InvoiceInterface)=> {
      if (r == null) {
        alert("Invoice not found");
        return;
      }
      
      if (this.transferToAddAmount == 0) {
        for (let payment of r.paymentsMade) {
          if (payment.method.toLowerCase() == "cash") {
            this.transferToAddAmount = payment.amount;
          }
        }
      }

      if (this.transferToAddAmount == 0) {
        alert("Amount cannot be zero");
        return;
      }

      this.transaction.cashDeposit.push({
        invoice: this.truncateTransferNote("inv " + this.transferToAddInv),
        amount: this.transferToAddAmount
      });

      this.transferToAddInv = "";
      this.transferToAddAmount = 0;
    });
  }

  save(closeDialog = true) {
    this.total = this.getTotal();

    this.transactionService.update(this.transaction).subscribe(() => {
      if (closeDialog) {
        this.close("sorted");
      }
    });
  }

  getTotal () {
    let total = 0;

    if (this.transaction.cashDeposit) {
      for (let transfer of this.transaction.cashDeposit) {
        total += transfer.amount;
      }
    }
    
    return total;
  }

  commit() {
    let transfers = [];

    for (let transfer of this.transaction.cashDeposit) {
      transfers.push({
          srcAccount: ACCOUNT.G72REVENUE,
          destAccount: ACCOUNT.REVENUE,
          amount: (transfer.amount / 100).toFixed(2),
          transactionDescription: transfer.invoice
      })
    }

    if (this.allowCommit) {
      this.jobService.create({
        job: Job.BANK_TRANSFER,
        date: {
          start: new Date()
        },
        data: {
          transfers: transfers
        }
      }).subscribe(r=> {
        // Also mark all cash revenue as sorted

        this.markSorted();
      });
    }
  }

  markSorted() {
    this.transaction.sorted = true;

    this.transactionService.update(this.transaction).subscribe(r=> {
      this.close("updated");
    })
  }

  close (action: string) {
    this.dialogRef.close(action);
  }

  updateTransferInvoice(transfer: { invoice: string }, invoice: string) {
    transfer.invoice = this.truncateTransferNote(invoice);
  }

  updateTransferToAddInv(invoice: string) {
    this.transferToAddInv = this.truncateTransferNote(invoice);
  }

  truncateTransferNote(note: string) {
    return (note || "").slice(0, TRANSFER_NOTE_MAX_LENGTH);
  }
  

  allowCommit() {
    return this.getTotal() != this.transaction.amount;
  }
}
